import { Base64 } from "js-base64";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext, SET_PAGE_STATE } from "../../../components/AppProvider";
import {
  AccountMergeResultLayer,
  CustomConfirmLayer,
} from "../../../components/UI/Dialog";
import { PostApiAcntIntg } from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { LoadginImgSrc } from "../../../resources/Assets";
import { closeLayerFn, openLayerFn } from "../../Layout";
import {
  setFilesMerge,
  setFilesMergeCancel,
} from "../../Nftf/Interface/NFTF/NativeApi";
import { Header } from "./Header";
import { MergeAcntInfo } from "./MergeAcntInfo";

export default props => {
  const { userinfo, phonecfg, cfg, pageState, dispatch } =
    useContext(AppContext);
  const [socketStatus, setSocketStatus] = useState("100");

  // const [timer, setTimer] = useState(10);
  const timer = 10;
  // 0: 대기, 1: 진행중,
  const [mergeStatus, setMergeStatus] = useState(0);

  // 통합결과 메세지
  const [dialog, setDialog] = useState({
    type: "check",
    title: "계정통합안내",
    msg: "계정 통합에 성공하였습니다 통합계정으로 자가건강관리정보, 진료자료, 교육자료, 병원연동정보가 통합되었습니다",
    msg2: <MergeAcntInfo />,
    data: {},
  });

  // 연결상태 확인 (n초당 갱신)
  const maxCnntTime = 10;

  // 계정통합 API
  const requestAcntIntg = () => {
    PostApiAcntIntg(
      userinfo,
      cfg,
      phonecfg,
      Base64.decode(props.match.params.trgtUserToken)
    )
      .then(res => {
        if (res.rsltCd === "E000") {
          //
          // setFilesMergeComplete(
          //   Base64.decode(props.match.params.trgtUserToken),
          //   userinfo.userToken
          // );
          if (phonecfg.phoneOS === "ANDROID") {
            openLayerFn($("#acntMrgLayer"));
          } else {
            setFilesMerge(
              Base64.decode(props.match.params.trgtUserToken),
              userinfo.userToken
            );
          }
        } else {
          if (phonecfg.phoneOS === "IOS") {
            setFilesMergeCancel(
              Base64.decode(props.match.params.trgtUserToken),
              userinfo.userToken
            );
          }
          alert("정보 통합에 실패했습니다.");
        }
      })
      .catch(err => {
        console.log("err :: ", err);
      });
  };

  useEffect(() => {
    if (props.match.params.trgtUserToken != "null") {
      requestAcntIntg();
    }
  }, []);

  useEffect(() => {
    if (pageState.reload === 1) {
      openLayerFn($("#acntMrgLayer"));
      dispatch({
        type: SET_PAGE_STATE,
        data: { type: "reload", state: 0 },
      });
    }
  }, [pageState.reload]);

  const intervalErrMsg = () => {
    if (mergeStatus === 0) {
      // alert("파일 통합을 시작하지 못했습니다.");
      alert("파일 통합 중 문제가 발생했습니다.");
      return;
    }

    if (mergeStatus === 1) {
      alert("파일 통합 중 문제가 발생했습니다.");
      return;
    }
  };

  const fileMergeRstMsg = () => {
    switch (value) {
      case 0:
        return "성공";
      case 1:
        return "실패";
    }
  };

  return (
    <ContainerWhite>
      {/* <Header backUrl={() => openLayerFn($("#cstmCnfmLayer"))} /> */}
      <Header backUrl="none" />
      <div>
        {/* <Title>자료통합</Title> */}
        {socketStatus === "100" && (
          <div
            style={{
              textAlign: "center",
              width: "100%",
              top: "40%",
              position: "absolute",
            }}>
            <img src={LoadginImgSrc} style={{ width: "3rem" }} />
            <TextArea style={{ marginTop: "24px" }}>
              <TextP>계정을 통합 중입니다.</TextP>
              <TextP>페이지를 유지하시고 잠시만 기다려주세요</TextP>
            </TextArea>
          </div>
        )}
      </div>

      {socketStatus === "000" && (
        <BottomBtn
          onClick={() => {
            setFilesMerge(
              Base64.decode(props.match.params.trgtUserToken),
              userinfo.userToken
            );
            setSocketStatus("100");
          }}>
          시작하기
        </BottomBtn>
      )}
      {socketStatus === "400" && (
        <BottomBtn
          onClick={() => {
            setFilesMerge(
              Base64.decode(props.match.params.trgtUserToken),
              userinfo.userToken
            );
            setSocketStatus("100");
          }}>
          재요청
        </BottomBtn>
      )}

      {socketStatus === "200" && (
        <BottomBtn onClick={() => checkPhoneNumber()}>통합하기</BottomBtn>
      )}
      <CustomConfirmLayer
        priv="priv"
        title={"통합취소"}
        msg={"진행하던 내용은 전부 삭제됩니다."}
        msg2={"그래도 취소하시겠습니까?"}
        // handleConfirmCB={() => _O.Open("/")}
        handleConfirmCB={() => alert("메인페이지 이동")}
        handleConfirmCBText={"취소하기"}
        handleCancelCB={() => closeLayerFn($("#cstmCnfmLayer"))}
        handleCancelCBText={"닫기"}
        setCookieBtn={false}
        textAlign="left"
      />
      <AccountMergeResultLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={() => _O.Open("/mp/myInfo/view")}
        handleConfirmCBText={"확인"}
        setCookieBtn={false}
      />
    </ContainerWhite>
  );
};

export const ContainerWhite = styled.div`
  background: white;
`;

export const Title = styled.div`
  margin: 37px 16px 0px 16px;
  color: #000;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const BottomBtn = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #333;
  background: #333;

  color: #fff;
  font-family: Malgun Gothic;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  margin: 0 20px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 40px);
`;

const TextArea = styled.div`
  margin: 16px;
`;

const TextP = styled.div`
  color: #898989;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
